import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';

const Terms = () => {
  return (
    <>
      <Navigation />
      <main className="main-content">
        <div className="page-container">
          <div className="container">
            <h1>Terms and Conditions</h1>
            <p>Last updated: {new Date().toLocaleDateString()}</p>

            <section className="policy-section">
              <h2>1. Acceptance of Terms</h2>
              <p>By accessing and using ä.dk, you accept and agree to be bound by these Terms and Conditions.</p>
            </section>

            <section className="policy-section">
              <h2>2. Service Description</h2>
              <p>ä.dk provides URL shortening services. Free users' URLs expire after 7 days, while premium subscribers have permanent URLs.</p>

              <h3>2.1 URL Shortening</h3>
              <ul>
                <li>You may not create URLs that violate any laws or rights</li>
                <li>We reserve the right to delete any URL without notice</li>
                <li>Free tier URLs expire after 7 days</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>3. User Responsibilities</h2>
              <p>You agree <i>not</i> to:</p>
              <ul>
                <li>Share malicious or harmful URLs</li>
                <li>Attempt to bypass our security measures</li>
                <li>Use our service for spam or abuse</li>
                <li>Resell or redistribute our services</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>4. Premium Subscriptions</h2>
              <p>Premium subscriptions are billed monthly and include:</p>
              <ul>
                <li>Permanent URLs that don't expire</li>
                <li>Editable target URLs</li>
                <li>Click analytics</li>
                <li>Priority support</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>5. Limitation of Liability</h2>
              <p>ä.dk is provided "as is" without warranties of any kind. We are not responsible for any damages arising from the use of our service.</p>
            </section>

            <section className="policy-section">
              <h2>6. Contact</h2>
              <p>For questions about these Terms, contact mail@aumlaut.dk</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
      </>
  );
};

export default Terms;
